import "./GridCards.css";

export const GridCards = ({ children }: { children: React.ReactNode }) => {
  return <div className='grid-cards'>{children}</div>;
};
